import React from 'react'
import AttachFile from './attachFile'
import { attachmentList } from '../constant'

const Attachment = ({ props }) => {
    // const { rcAttachFile } = props
    return (
        <>
            <div className="div-attachment content-block p-3">
                <div className="block-title">เอกสารแนบ</div>
                {attachmentList.map((item, index) => {
                    return (
                        <div className='py-2' key={index}>
                            <AttachFile props={props} title={item.title} docType={item.docType} />
                        </div>
                    )
                })}
            </div>
        </>
    )
}

export default Attachment